import React, { useState } from 'react';
import PropTypes from 'prop-types';

const CompanyContext = React.createContext([{}, () => {}]);

const CompanyProvider = ({ children }) => {
  const [company, setCompany] = useState();

  return (
    <CompanyContext.Provider value={[company, setCompany]}>
      {children}
    </CompanyContext.Provider>
  );
};

CompanyProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export { CompanyContext, CompanyProvider };
